import React, { FunctionComponent as FC, useState, useEffect } from 'react';
import './index.scss';

import Login from './LoginForm';

import chromeLogoUrl from "../../../../assets/chrome.png";
import firefoxLogoUrl from "../../../../assets/firefox.png";

import { ConfigProvider, Modal } from 'antd';
import { Layout } from 'antd';

const { Header, Content, Footer } = Layout;


interface LoginPageProps {

}

const LoginPage: FC<LoginPageProps> = (props) => {
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState<boolean>(false);

  const {
  } = props

  // 页面加载时自动弹出 modal
  useEffect(() => {
    // 延迟一点时间确保页面完全加载
    const timer = setTimeout(() => {
      setIsWelcomeModalOpen(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Modal handlers
  const handleWelcomeModalOk = () => {
    setIsWelcomeModalOpen(false);
  };

  const handleWelcomeModalCancel = () => {
    setIsWelcomeModalOpen(false);
  };


  const emailAddress = 'yifang.wang@fsu.edu';
  const [isCopyModalVisible, setIsCopyModalVisible] = useState(false);
  const copyEmailToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(emailAddress);
      setIsCopyModalVisible(true);
    } catch (err) {
      Modal.error({
        title: 'Copy Failed',
        content: 'Failed to copy email to clipboard.',
        centered: true,
      });
    }
  };
  const handleModalOk = () => {
    setIsCopyModalVisible(false);
  };

  return (
    <div className='login-page-div'>
      <Login />

      {/* Welcome Modal */}
      <Modal
        // title="Welcome to Funding the Frontier"
        closable={true}
        open={isWelcomeModalOpen}
        onOk={handleWelcomeModalOk}
        onCancel={handleWelcomeModalCancel}
        width="64vw"
        style={{
          maxHeight: '80vh',
          top: '5vh'
        }}
        bodyStyle={{
          maxHeight: '80vh',
          overflowY: 'auto'
        }}
        okText="Get Started"
        cancelText="Close"
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {/* Welcome Message */}
          <div>
            <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '18px' }}>Welcome to <span className='system-name'>Funding the Frontier</span> Platform!</div>
            <div style={{ marginBottom: '12px' }}>
            This project aims to visualize the broad impact of science and science funding. Please view the demo video for more details:
            </div>
            <div className="tour-media" style={{ marginTop: 8 }}>
              <video src={'/tour_references/v3-20250909/0915-compressed.mp4'} controls autoPlay loop muted playsInline />
            </div>
          </div>

          {/* Getting Started */}
          {/* <div>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Getting Started</div>
            <div>
              Please log in with your credentials to access the full platform.
              If you don't have an account,
              please contact the <span className='clickable-email' onClick={copyEmailToClipboard}>administrator</span> for access.
            </div>
          </div> */}
          <div>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Join the Waiting List</div>
            <div> Our platform is not yet open to the public.
                  Join the <a href='https://forms.gle/knCMpR88G37tvLdT6' target="_blank">waiting list</a> and be the first to know when new access becomes available.
                  {/* Please join the <a href='https://forms.gle/knCMpR88G37tvLdT6' target="_blank">waiting list</a> and we'll keep you updated as the project progresses. */}
            </div>
          </div>

          {/* Additional Info */}
          <div style={{
            // backgroundColor: '#f0f7ff',
            // padding: '12px',
            // borderRadius: '6px',
            // border: '1px solid #ddb892'
          }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Recommended Browsers</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              For the best experience, please use
              <img src={chromeLogoUrl} alt="Chrome" style={{ height: '20px', margin: '0 4px' }} />
              or
              <img src={firefoxLogoUrl} alt="Firefox" style={{ height: '20px', margin: '0 4px' }} />
              .
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title={null}
        open={isCopyModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalOk}
        closable={false}
        okText="OK"
        cancelButtonProps={{ style: { display: 'none' } }}
        className="email-copy-modal"
        style={{ top: 50 }}
        transitionName=""
      >
        <div className="modal-content">
          <div className="modal-message">Copied: {emailAddress}</div>
        </div>
      </Modal>
    </div>
  )
}

export default LoginPage